export enum ScheduleStatus {
    NOTIFIED,
    ALLOCATED,
    PARTIALLY_ALLOCATED,
    TO_BE_ALLOCATED
}
